import axios from "axios";
import { defaultOptions } from "./helper";

export function postPrintingExpenseDetails(token, data) {
  return axios.post(`/expenses/printing`, data, defaultOptions(token));
}
